var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-scroll-y-reverse-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{attrs:{"active":_vm.active,"installed":_vm.installed,"modal":_vm.modal,"dev":_vm.dev}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }